import React from 'react';
import {
  Checkbox,
  Divider,
  Tab,
  Tabs,
  Select,
  ToggleButtonGroup,
  ToggleButton,
  IconButton,
  InputAdornment,
  InputBase,
  MenuItem
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Skeleton } from '@mui/material';
import AllTabIcon from '@mui/icons-material/List';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import AcceptedIcon from '@mui/icons-material/ThumbUp';
import TrashIcon from '@mui/icons-material/Delete';
import PrivateIcon from '@mui/icons-material/HideSourceSharp';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ListIcon from '@mui/icons-material/List';
import TodayIcon from '@mui/icons-material/Today';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import { useNotesFilterContext } from 'modules/notes/NotesFilterContextProvider';

const useStyles = makeStyles((theme) => ({
  notes: {
    width: '100%',
    marginTop: theme.spacing(0)
  },
  note: {
    margin: theme.spacing(0)
  },
  day: {
    background: theme.skelton?.color,
    width: theme.spacing(20),
    height: 25
  },
  dayDuration: {
    background: theme.skelton?.color,
    width: theme.spacing(20),
    height: 25
  },
  collapseExpandDay: {
    background: theme.skelton?.color,
    width: theme.spacing(3),
    height: 25,
    marginLeft: theme.spacing(0.5)
  },
  noteDate: {
    display: 'flex',
    background: '#e0e0e0',
    marginBottom: theme.spacing(0.5),
    marginTop: theme.spacing(0.5)
  },
  summary: {
    display: 'flex',
    marginTop: theme.spacing(1),
    justifyContent: 'space-between'
  },
  summaryLeft: {
    display: 'flex',
    width: '50%',
    alignItems: 'center'
  },
  summaryRight: {
    display: 'flex',
    width: '50%',
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(3.25),
    alignItems: 'center'
  },
  details: {
    display: 'flex',
    marginBottom: theme.spacing(0.2),
    marginLeft: theme.spacing(1),
    justifyContent: 'space-between'
  },
  detailsLeft: {
    display: 'flex',
    width: '50%'
  },
  detailsRight: {
    display: 'flex',
    width: '50%',
    justifyContent: 'top',
    alignItems: 'flex-end',
    flexDirection: 'column',
    paddingRight: theme.spacing(7)
  },
  subject: {
    display: 'flex',
    background: theme.skelton?.color,
    width: '60%',
    height: 25,
    marginLeft: theme.spacing(0.5)
  },
  startEndTime: {
    display: 'flex',
    background: theme.skelton?.color,
    width: theme.spacing(30),
    height: 25
  },
  durationDetail: {
    display: 'flex'
  },
  detailsRightLine2: {
    background: theme.skelton?.color,
    width: theme.spacing(10),
    height: 25,
    marginTop: theme.spacing(-0.5)
  },
  duration: {
    display: 'flex',
    background: theme.skelton?.color,
    width: theme.spacing(8),
    height: 25,
    marginLeft: theme.spacing(0.5)
  },
  meetingDetail: {
    display: 'flex',
    width: '80%',
    flexDirection: 'column'
  },
  checkbox: {
    alignSelf: 'center',
    marginLeft: theme.spacing(0)
  },
  checkbox1: {
    alignSelf: 'center',
    marginLeft: theme.spacing(1)
  },
  chip: {
    background: theme.skelton?.color,
    marginLeft: theme.spacing(0.5),
    width: 120,
    height: theme.spacing(4),
    borderRadius: theme.spacing(1.8)
  },
  chipContainer: {
    display: 'flex',
    marginTop: theme.spacing(-1)
  },
  folderBtnContainer: {
    width: '50%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: theme.spacing(80),
    marginLeft: theme.spacing(-2)
  },
  avatar: {
    background: theme.skelton?.color,
    width: theme.spacing(5.5),
    height: theme.spacing(5.5),
    alignSelf: 'center',
    marginRight: theme.spacing(1)
  },
  customLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  topLeft: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: theme.spacing(1.8),
    marginLeft: theme.spacing(1.6),
    marginbottom: theme.spacing(10),
    marginTop: theme.spacing(-2)
  },
  header: {
    display: 'flex',
    marginTop: theme.spacing(1)
  },
  headerLeft: {
    display: 'flex',
    justifyContent: 'flex-start',
    widht: '50%',
    marginLeft: theme.spacing(1)
  },
  headerRight: {
    display: 'flex',
    width: '50%',
    justifyContent: 'flex-end',
    marginRight: theme.spacing(1),
    padding: theme.spacing(2)
  },
  tabs: {
    display: 'flex'
  },
  tab: {
    background: theme.skelton?.color,
    width: theme.spacing(14),
    height: theme.spacing(3.5)
  },
  headerContent: {
    background: theme.skelton?.color,
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(0.75),
    width: theme.spacing(8.5),
    height: theme.spacing(3)
  },
  divider: {
    marginBottom: theme.spacing(2.5),
    borderBottomWidth: theme.spacing(0.25),
    width: theme.spacing(185),
    color: theme.palette.grey[200]
  },
  searchBox: {
    marginRight: theme.spacing(2)
  },
  selector: {
    margin: theme.spacing(0, 2, 1.5, 2),
    height: theme.spacing(4.5),
    width: theme.spacing(14)
  },
  togglebtnDown: {
    border: 'none',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.default
  },
  togglebtnUp: {
    border: 'none',
    backgroundColor: theme.palette.grey[300]
  },
  grouped1: {
    margin: theme.spacing(0.25, 1, 1, 1),
    height: theme.spacing(3.75)
  },
  grouped2: {
    margin: theme.spacing(0, 1, 1.25, 1),
    height: theme.spacing(4.5)
  },
  icons: {
    fontSize: 'small'
  },
  status: {
    display: 'flex',
    background: theme.skelton?.color,
    width: theme.spacing(8),
    height: theme.spacing(3),
    marginRight: theme.spacing(2.5)
  },
  listIcon: {
    padding: theme.spacing(0.5),
    backgroundColor: theme.palette.grey[300],
    borderRadius: theme.shape.borderRadius
  },
  searchContainer: {
    display: 'flex',
    height: theme.spacing(4.5),
    margin: theme.spacing(2, 4.5, 0, 2.5)
  },
  input: {
    backgroundColor: theme.palette.grey[300],
    width: '100%',
    borderRadius: theme.spacing(0.5),
    '& .MuiInputBase-input::placeholder': {
      opacity: 0.9
    },
    fontWeight: 600,
    fontSize: theme.typography.body2.fontSize
  },
  iconSearch: {
    opacity: 0.9,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(-1)
  },
  iconDropDown: {
    marginRight: theme.spacing(1)
  },
  menuItem: {
    display: 'flex',
    background: theme.skelton?.color,
    width: theme.spacing(8.5),
    height: theme.spacing(3),
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(1)
  }
}));

type NotesListSkeletonProps = {
  showHeaders?: boolean;
};

export const NotesListSkeleton: React.FC<NotesListSkeletonProps> = ({
  showHeaders = true
}: NotesListSkeletonProps) => {
  const classes = useStyles();
  const {
    filterContext: { selectedClassification }
  } = useNotesFilterContext();
  return (
    <div
      className={classes.notes}
      data-testid={`notes-list-skeleton_${selectedClassification.toLowerCase()}`}
    >
      {showHeaders && (
        <>
          <div className={classes.header}>
            {(() => {
              return (
                <>
                  <Tabs
                    variant="scrollable"
                    scrollButtons="auto"
                    className={classes.headerLeft}
                  >
                    <Tab
                      icon={<AllTabIcon data-testid="allTabIcon" />}
                      label={
                        <Skeleton
                          className={classes.tab}
                          data-testid="headerSkeleton"
                        ></Skeleton>
                      }
                      className={classes.tabs}
                    />
                    <Tab
                      icon={<InboxIcon data-testid="inboxIcon" />}
                      label={
                        <Skeleton
                          className={classes.tab}
                          data-testid="headerSkeleton"
                        ></Skeleton>
                      }
                      className={classes.tabs}
                    />
                    <Tab
                      icon={<PrivateIcon data-testid="privateIcon" />}
                      label={
                        <Skeleton
                          className={classes.tab}
                          data-testid="headerSkeleton"
                        ></Skeleton>
                      }
                      className={classes.tabs}
                    />
                    <Tab
                      icon={<AcceptedIcon data-testid="acceptedIcon" />}
                      label={
                        <Skeleton
                          className={classes.tab}
                          data-testid="headerSkeleton"
                        ></Skeleton>
                      }
                      className={classes.tabs}
                    />
                    <Tab
                      icon={<TrashIcon data-testid="trashIcon" />}
                      label={
                        <Skeleton
                          className={classes.tab}
                          data-testid="headerSkeleton"
                        ></Skeleton>
                      }
                      className={classes.tabs}
                    />
                  </Tabs>
                  <div className={classes.headerRight}>
                    <Skeleton
                      className={classes.headerContent}
                      data-testid="headerSkeleton"
                    ></Skeleton>
                    <Select
                      displayEmpty
                      data-testid="selector"
                      className={classes.selector}
                    >
                      <MenuItem>
                        <Skeleton className={classes.menuItem}></Skeleton>
                      </MenuItem>
                    </Select>
                    <Skeleton
                      className={classes.headerContent}
                      data-testid="headerSkeleton"
                    ></Skeleton>
                    <ToggleButtonGroup
                      className={classes.grouped1}
                      size="small"
                      data-testid="change-order"
                    >
                      <ToggleButton
                        className={classes.togglebtnDown}
                        value={'center'}
                      >
                        <ArrowDownwardIcon className={classes.icons} />
                      </ToggleButton>
                      <ToggleButton
                        className={classes.togglebtnUp}
                        value={'center'}
                      >
                        <ArrowUpwardIcon className={classes.icons} />
                      </ToggleButton>
                    </ToggleButtonGroup>
                    <ToggleButtonGroup
                      className={classes.grouped2}
                      size="small"
                      data-testid="view-type"
                    >
                      <ToggleButton value={'center'}>
                        <TodayIcon />
                      </ToggleButton>
                      <ToggleButton
                        value={'center'}
                        className={classes.listIcon}
                      >
                        <ListIcon />
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </div>
                </>
              );
            })()}
          </div>
          <Divider
            orientation="horizontal"
            className={classes.divider}
            data-testid="headerDivider"
          ></Divider>
          <div className={classes.searchContainer}>
            <InputBase
              data-testid="search-box"
              className={classes.input}
              placeholder={'Search'}
              startAdornment={
                <InputAdornment position="start">
                  <SearchSharpIcon className={classes.iconSearch} />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <ArrowDropDownIcon className={classes.iconDropDown} />
                </InputAdornment>
              }
              fullWidth
            />
          </div>
        </>
      )}
      <div className={classes.summary}>
        <div className={classes.summaryLeft}>
          <Checkbox disabled className={classes.checkbox1}></Checkbox>
          <Skeleton className={classes.day}></Skeleton>
        </div>
        <div className={classes.summaryRight}>
          <Skeleton className={classes.dayDuration}></Skeleton>
        </div>
      </div>
      <div>
        {Array.from(new Array(1)).map((_item, index) => (
          <div key={index} className={classes.note}>
            <div className={classes.noteDate}>
              <div className={classes.summaryLeft}>
                <Checkbox disabled className={classes.checkbox1}></Checkbox>
                <Skeleton className={classes.day}></Skeleton>
              </div>
              <div className={classes.summaryRight}>
                <Skeleton className={classes.dayDuration}></Skeleton>
                <IconButton size="small">
                  <ExpandLessIcon />
                </IconButton>
              </div>
            </div>

            {Array.from(new Array(3)).map((_item, index) => (
              <div className={classes.details} key={index}>
                <div className={classes.detailsLeft}>
                  <Checkbox disabled className={classes.checkbox}></Checkbox>
                  <Skeleton variant={'circular'} className={classes.avatar} />
                  <div className={classes.meetingDetail}>
                    <Skeleton className={classes.subject} />
                    <div className={classes.chipContainer}>
                      <Skeleton className={classes.chip} />
                      <Skeleton className={classes.chip} />
                      <Skeleton className={classes.chip} />
                    </div>
                  </div>
                </div>
                <div className={classes.detailsRight}>
                  <div className={classes.durationDetail}>
                    <Skeleton className={classes.status} />
                    <Skeleton className={classes.startEndTime} />
                  </div>
                  <div className={classes.customLabel}>
                    <Skeleton className={classes.chip} />
                    <Skeleton className={classes.chip} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
